/*
 Created by qing 2019/11/20 4:11 下午
 des : 汇总组件
 */
import BaseItem from "../BaseItem"
import {
  SUMMARY_TYPE__SUM,
  SUMMARY_TYPE__MULTIPLY,
  FORM_ITEM__SUMMARY,
  SUMMARY_TIME_CHOOSE_TYPE_EMPTY,
  SUMMARY_TIME_CHOOSE_TYPE_ALL,
  DATE_TYPE__DAY,
  DATE_TYPE__SECTION,
  SUMMARY_TYPE__AVERAGE,
  SUMMARY_TYPE__MAX,
  SUMMARY_TYPE__MIN,
  SUMMARY_TYPE__LATEST,
  SUMMARY_TYPE__EARLIEST, SUMMARY_TYPE__COUNT, DATA_TYPE__STRING, DATA_TYPE__JSON, DATA_TYPE__NUMBER
} from "../types"


class Summary extends BaseItem {

  constructor() {
    super()
    this.value = {
      summaryValue: 0,
      instanceIdList: [],
      filter: null
    }
    this.showTitle = ""
    this.relateAppId = ""    // 关联的AppId",
    this.relateFormId = ""   // 关联的表单Id",
    this.relateFieldId = ""  // 关联的表单Id",
    this.showMethod = 0      // 操作类型是否显示 0 否 1 是
    this.summaryWay = 'SUM'  // 0 累加 1 累乘
    this.filter = {
      relation: "and",  //条件之间的关系 and查询 或者 or 查询
      notJumpEmpty: 0, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: []
    }
    this.preFilterInfo = {
      relation: "and",
      notJumpEmpty: 0, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: []
    }
    this.showButton = 1      // 0 否 1 是
    this.hiddenFieldIdList = [] // 隐藏汇总表单的字段
  }

  get title() {
    return this.fieldTitle || Summary._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

Summary._title = '数据汇总'
Summary.type = FORM_ITEM__SUMMARY
Summary.use = true
Summary.prototype.icon = 'iconfont icon-huizong'
// 数据类型
Summary.prototype.dataType = DATA_TYPE__NUMBER

Summary.prototype.type = Summary.type
Summary.prototype.summaryTypeList = [
  {
    value: SUMMARY_TYPE__SUM,
    label: '累加'
  },
  {
    value: SUMMARY_TYPE__MULTIPLY,
    label: '累乘'
  },
  {
    value: SUMMARY_TYPE__COUNT,
    label: '计数'
  },
  {
    value: SUMMARY_TYPE__AVERAGE,
    label: '平均值'
  },
  {
    value: SUMMARY_TYPE__MAX,
    label: '最大'
  },
  {
    value: SUMMARY_TYPE__MIN,
    label: '最小'
  },
  {
    value: SUMMARY_TYPE__LATEST,
    label: '时间最晚'
  },
  {
    value: SUMMARY_TYPE__EARLIEST,
    label: '时间最早'
  }
]
Summary.prototype.timeChooseTypeList = [
  {
    value: SUMMARY_TIME_CHOOSE_TYPE_EMPTY,
    label: '允许起止时间某一个为空'
  },
  {
    value: SUMMARY_TIME_CHOOSE_TYPE_ALL,
    label: '必须设置起止时间'
  }
]
Summary.prototype.dataTypeList = [
  {
    label: '精确到天',
    value: DATE_TYPE__DAY
  },
  {
    label: '精确到秒',
    value: DATE_TYPE__SECTION
  }
]

Summary.prototype.getValue = function () {
  return this.value
}
Summary.prototype.setValue = function (val) {
  if (val) {
    if (val.hasOwnProperty('summaryValue')) this.value.summaryValue = val.summaryValue
    if (val.hasOwnProperty('instanceIdList')) this.value.instanceIdList = val.instanceIdList
    if (val.hasOwnProperty('filter')) {
      this.value.filter = val.filter
    } else {
      this.value.filter = this.filter
    }
  } else {
    this.value = {
      summaryValue: 0,
      instanceIdList: [],
      filter: null
    }
  }
}
Summary.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    showTitle: this.showTitle,
    relateAppId: this.relateAppId,
    relateFormId: this.relateFormId,
    relateFieldId: this.relateFieldId,
    summaryWay: this.summaryWay,
    filter: this.filter,
    preFilterInfo: this.preFilterInfo,
    showButton: this.showButton,
    showMethod: this.showMethod,
    hiddenFieldIdList: this.hiddenFieldIdList
  }
}
Summary.prototype.setConf = function (opts) {
  this.setBase(opts)

  if (opts.showTitle) this.showTitle = opts.showTitle
  if (opts.relateAppId) this.relateAppId = opts.relateAppId
  if (opts.relateFormId) this.relateFormId = opts.relateFormId
  if (opts.relateFieldId) this.relateFieldId = opts.relateFieldId
  if (opts.hiddenFieldIdList) this.hiddenFieldIdList = opts.hiddenFieldIdList
  if (opts.summaryWay) this.summaryWay = opts.summaryWay
  if (opts.filter) this.filter = opts.filter
  if (opts.preFilterInfo) this.preFilterInfo = opts.preFilterInfo
  if (opts.showButton === 0) this.showButton = 0
  if (opts.showMethod === 1) this.showMethod = 1
}
Summary.prototype.valueToString = function (value) {
  value = value || this.value
  return value.summaryValue
}

export default Summary
